import React from "react";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import Step from "./Step";

function Steps(props) {
  const {items} = props;
  return (
    <Grid container spacing={8} justify={`space-between`}>
      {items.map(({id, title, description}) => (
        <Grid key={id} item xs={12} md={4}>
          <Step id={id} title={title} description={description} />
        </Grid>
      ))}
    </Grid>
  );
}

Steps.propTypes = {
  items: PropTypes.array
};

export default Steps;
